var _defs, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _circle2, _line5, _path8, _circle3, _path9, _path10, _path11, _path12, _path13, _circle4, _circle5, _circle6, _circle7, _path14, _path15, _ellipse, _path16, _line6, _line7, _line8, _path17, _path18, _ellipse2, _path19, _line9, _line10, _line11, _path20, _path21, _ellipse3, _path22, _line12, _line13, _line14, _path23, _path24, _ellipse4, _path25, _line15, _line16, _line17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackingBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-dasharray:2.28 3.79;}.cls-1,.cls-2{stroke:#0b1320;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.2,101s17.43,2.36,29.15,12.62c12.5,10.94,12.64,31.44,12.64,31.44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.61,82.25s46.5-14.35,73.69,11.9c30.42,29.35,16.92,71.15,16.92,71.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.8,111.52s2.77-19.17,26.05-31,39.08-7.32,39.08-7.32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.69,
    cy: 84.33,
    r: 33.51
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.35,93.15,134.81,91c-.51-1.52-2.7-3.24-11.34-3.22l-1.08,5.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117,93.15l-1.08-5.4c-8.64,0-10.8,1.62-11.34,3.24L104,93.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.79,72.49a1.07,1.07,0,0,1,1.08,1.08v2.16a1.08,1.08,0,0,1-1.08,1.08,43.21,43.21,0,0,1-2.7,5.94c-.67,1-1.62,2.7-5.4,2.7s-4.73-1.69-5.4-2.7a43.21,43.21,0,0,1-2.7-5.94,1.08,1.08,0,0,1-1.08-1.08V73.57a1.08,1.08,0,0,1,1.08-1.08,1.06,1.06,0,0,0,1.08,1.08,12.71,12.71,0,0,0,1.08-4.32c2.16,0,8.61-.32,9.72-2.16,0,2.16,2.16,4.32,2.16,4.32A2.45,2.45,0,0,0,127.79,72.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.51,73.57a1.08,1.08,0,0,1,1.08-1.08,1.06,1.06,0,0,0,1.08,1.08,12.71,12.71,0,0,0,1.08-4.32c2.16,0,8.61-.32,9.72-2.16,0,2.16,2.16,4.32,2.16,4.32a2.5,2.5,0,0,0,2.16,1.08V69.25s0-5.94-5.4-5.94c.54-1.08-.74-1.62-2.7-1.62-9.18,0-9.18,8.64-9.18,8.64Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 115.91,
    y1: 74.79,
    x2: 118.07,
    y2: 74.79
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 116.99,
    y1: 75.56,
    x2: 116.99,
    y2: 74.79
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 121.31,
    y1: 74.79,
    x2: 123.47,
    y2: 74.79
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 122.39,
    y1: 75.56,
    x2: 122.39,
    y2: 74.79
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.69,
    cy: 88.83,
    r: 1.08
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 119.69,
    y1: 93.15,
    x2: 119.69,
    y2: 89.91
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,78.81a2.15,2.15,0,0,1-1.44,3.76h-3.24"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 121.31,
    cy: 82.56,
    r: 1.08
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.07,81.48h0a1.92,1.92,0,0,1-1.62-1.08"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.9,93.36h33.57a3.05,3.05,0,0,1,3.05,3.05v18a0,0,0,0,1,0,0H99.85a0,0,0,0,1,0,0v-18A3.05,3.05,0,0,1,102.9,93.36Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.49,104a2,2,0,0,1-1.48-3.31,4,4,0,0,0-6.19,2.28,4,4,0,1,0,7.84,1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.85,114.43h39.67a0,0,0,0,1,0,0v0a4,4,0,0,1-4,4H103.89a4,4,0,0,1-4-4v0A0,0,0,0,1,99.85,114.43Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.32,176.72S58.61,160,69.53,136.24s26.13-30,26.13-30"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 28.94,
    cy: 116.51,
    r: 23.94
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.42,
    cy: 197.88,
    r: 23.94
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 185.36,
    cy: 145.08,
    r: 23.94
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 241.06,
    cy: 178.99,
    r: 23.94
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.8,108.88a2.52,2.52,0,0,1,2.5,2.54v12.72a2.52,2.52,0,0,1-2.5,2.54H19.57a2.52,2.52,0,0,1-2.5-2.54"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.28,106.33H17.1a2.52,2.52,0,0,0-2.52,2.53v12.76a2.52,2.52,0,0,0,2.52,2.52H38.28a2.52,2.52,0,0,0,2.52-2.52V108.86A2.52,2.52,0,0,0,38.28,106.33Zm-15,15.26a6.36,6.36,0,1,1,6.24-6.35A6.3,6.3,0,0,1,23.32,121.59Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 23.32,
    cy: 113.96,
    rx: 2.5,
    ry: 2.54
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.32,121.59a6.2,6.2,0,0,0,4.41-1.85,4.63,4.63,0,0,0-8.82,0A6.2,6.2,0,0,0,23.32,121.59Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.06,
    y1: 111.42,
    x2: 38.31,
    y2: 111.42
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.06,
    y1: 115.24,
    x2: 38.31,
    y2: 115.24
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.06,
    y1: 119.05,
    x2: 38.31,
    y2: 119.05
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.28,190.25a2.52,2.52,0,0,1,2.5,2.54V205.5a2.52,2.52,0,0,1-2.5,2.55H61.05a2.52,2.52,0,0,1-2.5-2.55"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.76,187.7H58.58a2.52,2.52,0,0,0-2.53,2.52V203a2.52,2.52,0,0,0,2.53,2.52H79.76A2.52,2.52,0,0,0,82.28,203V190.22A2.52,2.52,0,0,0,79.76,187.7ZM64.8,203A6.36,6.36,0,1,1,71,196.6,6.3,6.3,0,0,1,64.8,203Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 64.8,
    cy: 195.33,
    rx: 2.5,
    ry: 2.54
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.8,203a6.16,6.16,0,0,0,4.41-1.86,4.63,4.63,0,0,0-8.82,0A6.15,6.15,0,0,0,64.8,203Z"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.54,
    y1: 192.79,
    x2: 79.78,
    y2: 192.79
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.54,
    y1: 196.6,
    x2: 79.78,
    y2: 196.6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.54,
    y1: 200.42,
    x2: 79.78,
    y2: 200.42
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.22,137.45a2.52,2.52,0,0,1,2.5,2.54v12.72a2.52,2.52,0,0,1-2.5,2.54H176a2.52,2.52,0,0,1-2.5-2.54"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.7,134.9H173.52a2.52,2.52,0,0,0-2.52,2.52v12.76a2.52,2.52,0,0,0,2.52,2.53H194.7a2.52,2.52,0,0,0,2.52-2.53V137.42A2.52,2.52,0,0,0,194.7,134.9Zm-15,15.26A6.36,6.36,0,1,1,186,143.8,6.3,6.3,0,0,1,179.74,150.16Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 179.74,
    cy: 142.53,
    rx: 2.5,
    ry: 2.54
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.74,150.16a6.16,6.16,0,0,0,4.41-1.86,4.63,4.63,0,0,0-8.82,0A6.16,6.16,0,0,0,179.74,150.16Z"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 188.48,
    y1: 139.99,
    x2: 194.73,
    y2: 139.99
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 188.48,
    y1: 143.8,
    x2: 194.73,
    y2: 143.8
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 188.48,
    y1: 147.62,
    x2: 194.73,
    y2: 147.62
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.93,171.36a2.52,2.52,0,0,1,2.49,2.55v12.71a2.51,2.51,0,0,1-2.49,2.54H231.69a2.51,2.51,0,0,1-2.49-2.54"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.41,168.82H229.22a2.52,2.52,0,0,0-2.52,2.52V184.1a2.52,2.52,0,0,0,2.52,2.52h21.19a2.52,2.52,0,0,0,2.52-2.52V171.34A2.52,2.52,0,0,0,250.41,168.82Zm-15,15.26a6.36,6.36,0,1,1,6.25-6.36A6.3,6.3,0,0,1,235.44,184.08Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 235.44,
    cy: 176.45,
    rx: 2.5,
    ry: 2.54
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.44,184.08a6.16,6.16,0,0,0,4.41-1.86,4.63,4.63,0,0,0-8.82,0A6.16,6.16,0,0,0,235.44,184.08Z"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 244.18,
    y1: 173.91,
    x2: 250.43,
    y2: 173.91
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 244.18,
    y1: 177.72,
    x2: 250.43,
    y2: 177.72
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 244.18,
    y1: 181.54,
    x2: 250.43,
    y2: 181.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingBig);
export default __webpack_public_path__ + "static/media/tracking_big.99575fc800f778ffb88f699e0634b584.svg";
export { ForwardRef as ReactComponent };